import React, { useEffect, useState } from 'react';
import { filter, size, toLower, pick, find } from 'lodash';
import { SearchIcon } from '../../icons/SearchIcon';
import { BorderedField, Flex } from '../../components/Flex';
import { CloseIcon } from '../../icons/CloseIcon';
import { SelectButton } from '../../components/SelectButton';
import { Button } from '../../components/Button';
import { Modal } from '../../components/Modal';
import { Form } from '../../components/Form';
import { Input } from "../../components/CustomInput";
import { SaveFilterButton } from './SaveFilterButton';
import { IconButton } from '../../icons/IconContainer';
import { FiltersIcon } from '../../icons/FilterIscon';
import { FiltersPanel } from './FiltersPanel';


const SearchBox = ({ context, searchOptions=[], filterOptions={}, setQueryParams, saveQueryFilter, saveFilterChanges, selectedFilter, hasChanges, width }) => {
    const initialState = {
        context: "",
        visible: false,
        filtersVisible: false
    };
    const [state, setState] = useState(initialState);

    useEffect(() => {
        if (context !== state.context) setState({ context: context || "" })
    }, [ context ]);

    const searchTextWidth = 260,
    marginRight = 8,
    saveFilterBtnWidth = 106,
    resetBtnWidth = 84,
    iconBtnWidth = 40;

    const calculateWidth = (option={}) => {
        let btnWidth = 0;
        let { title, options, value } = option;
        let charWidth = 7, padding = 12, arrowIconWidth = 24;
        if (typeof title == "string") {
            btnWidth = title.length * charWidth + marginRight + arrowIconWidth + padding*2; // 1 char ~ 2px, 8px margin after text, 24px arrow btn, 2*12px padding
        };
        if (Array.isArray(value) && value.length) {
            let optionTitle = find(options, o => toLower(o.key) == toLower(value[0]));
            if (optionTitle && typeof optionTitle.title == "string") {
                btnWidth += (optionTitle.title.length + 1)*7;
            }
            if (value.length > 1) {
                btnWidth += arrowIconWidth + marginRight;
            }
        };
        return btnWidth;
    };

    const renderSearchOprions = (searchOptions=[]) => {
        let searchBoxContainer = document.getElementById("search-box");
        if (searchBoxContainer && width > 0) {
            let freeSpace = width - searchTextWidth - marginRight - saveFilterBtnWidth - iconBtnWidth - marginRight; // search textbox + margin after + the Save filter button
            searchBoxContainer.childNodes.forEach((node, i) => {
                if (i > 0) {
                    freeSpace -= node.clientWidth + 12
                }
            });
            if (size(filterOptions) || selectedFilter) {
                freeSpace -= resetBtnWidth; // the Reset button
            }
            let options = filter(searchOptions, o => o && o.hasOwnProperty('options'));
            let btnWidths = options.map(o => calculateWidth(Object.assign(pick(o, ["title", "options"]), { value: filterOptions[o.key] || []})) + marginRight);
            let i = options.length;
            for (let index = 0; index < btnWidths.length; index++) {
                freeSpace -= btnWidths[index];
                if (freeSpace < 0) {
                    i = index;
                    break;
                }
            };
            options = options.slice(0, i);

            let renderedOptions = options.map(option => (
                <SelectButton
                    filterKey={option.key}
                    onSearch={(value) => setQueryParams({ [option.key]: option && option.type === "boolean" && value !== null ? Number(value) : value, page: 1 })}
                    selectedOptions={filterOptions[option.key]}
                    { ...option }
                >
                    {option.title}
                </SelectButton>
            ));

            if (filter(searchOptions, o => o && o.hasOwnProperty('options')).length > i) {
                renderedOptions.push(
                    <IconButton key={"trigger"} background={Object.keys(filterOptions).length ? "#D2E1FC" : "#E4EDFD"} hoverBackground="#D2E1FC" onClick={() => setState(state => ({ ...state, filtersVisible: true }))}>
                        <FiltersIcon color={Object.keys(filterOptions).length ? "var(--sp-paragraph-color)" : "var(--sp-label-color)"} />
                    </IconButton>)
            };
            return renderedOptions;
        };
        return null;
    };

    return(
        <>
            <Flex flex={1} gap={{ right: marginRight }} id="search-box-container">
                <BorderedField
                    background="white"
                    width={`${searchTextWidth}px`}
                    gap={{ right: 12 }}
                    position="relative"
                    padding={{ top: "4px", bottom: "4px", left: "48px", right: "10px" }}
                    style={{ height: "40px", minWidth: `${searchTextWidth}px` }}
                >
                    <SearchIcon color="var(--sp-text-grey-color)" style={{ position: "absolute", left: "12px", top: "6px" }}/>
                    <Flex align="center" flex={1} margin={{ left: "-2px", top: "-2px", right: "-2px", bottom: "-2px" }}>
                        <Input
                            autoFocus
                            bordered={false}
                            onPressEnter={() => setQueryParams({ context: state.context, page: 1 })}
                            value={state.context}
                            placeholder="Search..."
                            onChange={(e) => setState(state => ({ ...state, context: toLower(e.target.value) }))}
                        />
                        {typeof state.context == "string" && state.context.length
                            ? <CloseIcon
                                size={24}
                                color="var(--sp-error-color)"
                                hoverColor="var(--sp-error-hover-color)"
                                onClick={() => context ? setQueryParams({ filter: null, context: "", page: 1 }) : setState(state => ({ ...state, context: ""}))}
                                style={{ marginRight: "12px" }}
                            />
                        : null}
                    </Flex>
                </BorderedField>
                {Array.isArray(searchOptions) && searchOptions.length
                    ? renderSearchOprions(searchOptions)
                    : null}
                {size(filterOptions) || selectedFilter
                    ? <Button
                        link
                        onClick={() => setQueryParams({ filter: null, context: "", page: 1, ...searchOptions.reduce((a, b) => ({ ...a, [b.key]: null}), {}) })}
                    >
                        Reset
                    </Button>
                    : null}
                <SaveFilterButton
                    selected={selectedFilter}
                    saveFilter={() => setState(state => ({...state, visible: true }))}
                    saveChanges={saveFilterChanges}
                    hasChanges={hasChanges}
                >
                    Save filter
                </SaveFilterButton>
            </Flex>
            <Modal visible={state.visible} onCancel={() => setState(state => ({...state, visible: false }))}>
                <Form
                    title="Save filter"
                    onSubmit={(values) => {
                        saveQueryFilter(values);
                        setState(state => ({...state, visible: false }))
                    }}
                    onCancel={() => setState(state => ({...state, visible: false }))}
                >
                    <Form.Item name="name" label="Name" required >
                        <Input maxLength={30} />
                    </Form.Item>
                </Form>
            </Modal>
            <FiltersPanel
                visible={state.filtersVisible}
                onClose={() => setState(state => ({ ...state, filtersVisible: false }))}
                searchOptions={searchOptions}
                selectedOptions={filterOptions}
                setQueryParams={setQueryParams}
            />
        </>
    );
};

export { SearchBox };